import { useEffect } from 'react';
import styles from './IpScreen.module.scss';
import { IpRestS } from '../../../rest/ipRest-service';
import Google from "./../../../resources/images/google.png"
import { AuthMethods, IIntegrationPartner, IpNames, UserRole } from '../../../interfaces/interfaces';
import Integrations from '../../../components/common/Integrations/Integration';
import { getLocalUser } from '../../../components/functions/utilities';
import { PasswordForm } from './PasswordForm/PasswordForm';
import { useAppDispatch, useAppSelector } from '../../../redux/reduxHooks';
import { RiErrorWarningFill } from 'react-icons/ri';
import { clearCrendentialVerificationDetails } from '../../../redux/credentialVerification/credentialVerification';
import EmailOtpHome from '../EmailOtp/EmailOtpHome';

type Props = {
    ip: IIntegrationPartner,
    setStep: Function,
    setSelectedIp: (ip: IIntegrationPartner) => void,
    setSuccess: (value: boolean) => void,
}

const IpScreen = ({ ip, setStep, setSelectedIp, setSuccess }: Props) => {
    const { isCredentialValid, credentialError, integrationPartner } = useAppSelector(state => state.credentialVerification)
    const user = getLocalUser();
    const isAgency = user?.role == UserRole.Agency;
    const { currentClient } = useAppSelector((state) => state.agencyConfig);


    useEffect(() => {
        console.log('isCredentialValid', isCredentialValid, credentialError)
    }, [isCredentialValid])

    return (
        <>
            <div className={styles.ipScreen}>
                {
                    !isCredentialValid && credentialError == 'Invalid Credentials' && integrationPartner?.name == ip.companyName ?
                        <div className={styles.invalidCreds}>
                            <RiErrorWarningFill />
                            <h1>Incorrect Email or Password</h1>
                        </div>
                        : null
                }
                <img className={styles.smallerImg} src={ip?.logo} />
                <p>Connect Your <span>{ip?.companyName}</span> Account</p>
                {isAgency && ip?.authMethod != AuthMethods.password ?
                    <div className={styles.subText}>
                        <>You're about to connect {ip?.companyName}</> <br />
                        <>account(s) to <b>{currentClient?.name}</b>.</>
                    </div>
                    : null}
                <div className={styles.googleSignIn}>
                    {
                        ip?.companyName.includes("Google") ?
                            <img
                                src={Google}
                                onClick={() => {
                                    let currentUser = JSON.parse(JSON.stringify(user));
                                    currentUser = {
                                        ...currentUser,
                                        companyId: isAgency ? currentClient?.id : user?.companyId,
                                    }
                                    Integrations(
                                        ip.companyName,
                                        ip._id,
                                        currentUser,
                                        ip,
                                        2,
                                        () => { },
                                        () => { }
                                    )
                                }}
                            /> :
                            ip?.companyName.includes("Amazon") ?
                                <img alt="Login with Amazon" src="https://images-na.ssl-images-amazon.com/images/G/01/lwa/btnLWA_gold_390x92.png"
                                    onClick={() => {
                                        // const user = getLocalUser();
                                        let currentUser = JSON.parse(JSON.stringify(user));
                                        currentUser = {
                                            ...currentUser,
                                            companyId: isAgency ? currentClient?.id : user?.companyId,
                                        }
                                        Integrations(
                                            ip.companyName,
                                            ip._id,
                                            currentUser,
                                            ip,
                                            2,
                                            () => { },
                                            () => { }
                                        )
                                    }} />
                                : ip?.authMethod == 'password' ?
                                    <div>
                                        <PasswordForm ip={ip} setStep={setStep} setSelectedIp={setSelectedIp} setSuccess={setSuccess} />
                                    </div> : null

                        // : ip?.companyName.includes(IpNames.zepto) ?
                        //     <div>
                        //         <PasswordForm ip={ip} setStep={setStep} />
                        //     </div>
                        //     : ip?.companyName.includes(IpNames.myntra) ?
                        //         <div>
                        //             <PasswordForm ip={ip} setStep={setStep} />
                        //         </div> :

                        //         null
                    }
                </div>
            </div>
        </>)
}

export default IpScreen
